import { defaultColorPalette } from '@/constants/brandingThemes';
import { darkenHex } from '@/utils/color';
import { PaletteMode } from '@mui/material';
import { StateCreator, create } from 'zustand';
import { persist } from 'zustand/middleware';

type BrandingTheme = {
  originalPrimaryColor: string;
  primaryColor: string;
  originalSecondaryColor: string;
  secondaryColor: string;
  logoUrl: string;
  pageTitle: string;
};

type BrandingThemeState = {
  brandingTheme: BrandingTheme;
  mode: PaletteMode;
  setBrandingTheme: (brandingTheme: BrandingTheme) => void;
  setMode: (mode: PaletteMode) => void;
};

const defaultBrandingTheme: BrandingTheme = {
  originalPrimaryColor: defaultColorPalette.primary,
  primaryColor: defaultColorPalette.primary,
  originalSecondaryColor: defaultColorPalette.secondary,
  secondaryColor: defaultColorPalette.secondary,
  logoUrl:
    'https://acct-mngt-service-prod-statics.s3.amazonaws.com/company-logos/one-advisor-web.png',
  pageTitle: '1Advisor',
};

const brandingThemeState: StateCreator<BrandingThemeState> = set => ({
  brandingTheme: defaultBrandingTheme,
  mode: 'light',
  setBrandingTheme: brandingTheme => set({ brandingTheme }),
  setMode: mode =>
    set(state => ({
      mode,
      brandingTheme: {
        ...state.brandingTheme,
        primaryColor:
          mode === 'light'
            ? state.brandingTheme.originalPrimaryColor
            : darkenHex(state.brandingTheme.originalPrimaryColor, 10),
        secondaryColor:
          mode === 'light'
            ? state.brandingTheme.originalSecondaryColor
            : darkenHex(state.brandingTheme.originalSecondaryColor, 10),
      },
    })),
});

export const useBrandingTheme = create(
  persist(brandingThemeState, {
    name: 'branding-theme',
    partialize: state => ({
      brandingTheme: state.brandingTheme,
      mode: state.mode,
    }),
  }),
);
